import { Component } from '@angular/core';
import { WmsVcsPullDialogComponent } from './wms-vcs-pull-dialog/wms-vcs-pull-dialog.component';
import { WmsVcsPushDialogComponent } from './wms-vcs-push-dialog/wms-vcs-push-dialog.component';
import { WmsVcsViewDialogComponent } from './wms-vcs-view-dialog/wms-vcs-view-dialog.component';
import { WmsVcsCompareFileDiffDialogComponent } from './wms-vcs-compare-file-diff-dialog/wms-vcs-compare-file-diff-dialog.component';
import { WmsVcsCommitHistoryDialogComponent } from './wms-vcs-commit-history-dialog/wms-vcs-commit-history-dialog.component';
import { WmsVcsPushExternalRepoDialogComponent } from './wms-vcs-push-external-repo-dialog/wms-vcs-push-external-repo-dialog.component';
import { WmsVcsProjectChangesDialogComponent } from './wms-vcs-project-changes-dialog/wms-vcs-project-changes-dialog.component';
import {WmsVcsUserCredentialsComponent} from "@wms/app/vcs/components/wms-vcs-dialog/wms-vcs-user-credentials/wms-vcs-user-credentials.component";
import { WmsVcsCreateMrDialogComponent } from "@wms/app/vcs/components/wms-vcs-dialog/wms-vcs-create-mr-dialog/wms-vcs-create-mr-dialog.component";
@Component({
  standalone: true,
  selector: 'wms-vcs-dialog',
  templateUrl: './wms-vcs-dialog.component.html',
  styleUrls: ['./wms-vcs-dialog.component.less'],
  imports: [
    WmsVcsPullDialogComponent,
    WmsVcsPushDialogComponent,
    WmsVcsViewDialogComponent,
    WmsVcsCompareFileDiffDialogComponent,
    WmsVcsCommitHistoryDialogComponent,
    WmsVcsPushExternalRepoDialogComponent,
    WmsVcsProjectChangesDialogComponent,
    WmsVcsUserCredentialsComponent,
    WmsVcsCreateMrDialogComponent
  ],
})
export class WmsVcsDialogComponent {

  constructor() {}


}
